import GeneratedEntryLinkServiceApi from "./generated/GeneratedEntryLinkServiceApi"

class EntryLinkServiceApi extends GeneratedEntryLinkServiceApi {

}

export const entryLinkServiceApi = new EntryLinkServiceApi()
